import { Box, Image, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import Divider, { DividerColorScheme } from '../../Divider';
import QuoteIcon from './quote.svg';

interface QuoteCardProps {
  variant: 'bottomLeft' | 'topLeft' | 'bottomRight' | 'topRight';
}

const QuoteCard: React.FC<QuoteCardProps> = ({ children, variant }) => {
  const Styles = useMultiStyleConfig('QuoteCard', { variant });
  return (
    <Box sx={Styles.container} role="group">
      <Box __css={Styles.frame} />
      <Box __css={Styles.overlay}>
        <Box width="full">
          <Divider colorScheme={DividerColorScheme.GRAY}>
            <Image src={QuoteIcon as string} width={38} height={38} />
          </Divider>
        </Box>
        {children}
      </Box>
    </Box>
  );
};

export default QuoteCard;
